import React, { useEffect } from 'react';
import { Footer } from '@sbb/ui';
export default function FooterWrapper({ fixed, title, footerSections, footerBottomLinks, toTopButtonLabel, }) {
    useEffect(() => {
        const toTopButton = document.querySelector('.o-footer__toTopButton');
        if (!toTopButton) {
            return;
        }
        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                // use requestAnimationFrame to avoid performance issues
                window.requestAnimationFrame(() => {
                    toTopButton.style.display = window.scrollY > 450 ? 'block' : 'none';
                    ticking = false;
                });
                ticking = true;
            }
        };
        const scrollToTop = () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
        toTopButton.addEventListener('click', scrollToTop);
        window.addEventListener('scroll', onScroll);
        toTopButton.style.display = 'none';
        return () => {
            window.removeEventListener('scroll', onScroll);
            toTopButton.removeEventListener('click', scrollToTop);
        };
    }, []);
    useEffect(() => {
        const cookieLink = document.querySelector('.ts-cookie-link');
        if (!cookieLink)
            return;
        function openCookieSettings() {
            var _a;
            (_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
        }
        cookieLink.addEventListener('click', openCookieSettings);
        return () => {
            cookieLink.removeEventListener('click', openCookieSettings);
        };
    }, []);
    return (React.createElement(Footer, { fixed: fixed, title: title, footerSections: footerSections, footerBottomLinks: footerBottomLinks, toTopButtonLabel: toTopButtonLabel }));
}
